import { Schema, bool, isodate, string } from 'lib/schema';

export default class PublishHistoryEntry extends Schema {
  @string id = { default: null };

  @isodate created = { default: () => new Date().toISOString() };

  @bool processed;
}
